/**
 * Shared chrome for the dense extraction-table tier (AD, LDND, SB, LLP,
 * engine events, part movement).
 *
 * Two table tiers exist intentionally:
 * - `SortableTable` — roomier (`px-6` / `text-sm`) general-purpose lists.
 * - Extraction tables — dense (`px-2 py-1.5` / `text-xs`) wide data grids.
 *
 * Only the chrome (thead background, text tones) is unified across the two
 * tiers; the density difference stays. Append table-specific utilities with a
 * template literal, e.g. `` `${extractionTdClass} font-mono` ``.
 */
export const extractionTableClass = 'w-full text-xs';
export const extractionTheadClass = 'bg-gray-50 dark:bg-zinc-900 text-gray-500 dark:text-zinc-400';
export const extractionThClass = 'text-left px-2 py-1.5 font-medium whitespace-nowrap';
export const extractionTdClass = 'px-2 py-1.5 text-gray-900 dark:text-zinc-100 whitespace-nowrap';
export const extractionTbodyClass = 'divide-y divide-gray-200 dark:divide-zinc-700';
export const extractionRowClass = 'cursor-pointer hover:bg-gray-50 dark:hover:bg-zinc-900/60';
